// 订单-->订单管理-->中英文
export const orderLocale = {
    'zhCN': {
        orderProcessing: {
            SAPCode: 'SAPCode',
            confirmCancelReason: '确认取消？',
            canceSuccess: '取消成功',
            transportTypeNull: '运输方式不能为空',
            receiverAddressNull: '收货地址不能为空',
            cancelReasonNull: '取消原因不能为空',
            materialNull: '物料不能为空',
            warehouseNull: '库房不能为空',
            adjustedQuantityExceed: '调整量超过可调整范围',
            contractRepeat: '已扫描过该合同',
            processSucess: '处理成功',
            applicationDate: '申请日期',
            applicationTime: '申请时间',
            clientProvinceCity: '客户省份/城市',
            clientProvince: '客户省份',
            clientCity: '客户城市',
            applicant: '申请人',
            applicationNumber: '申请单号',
            clientName: '客户名称',
            clientAddress: '客户地址',
            clientShortName: '客户简称',
            shipperName: '货主名称',
            clientShortPHCode: '客户PHCode',
            isOverdraft: '是否超额',
            overdraftMoney: '超额金额',
            overdraftPercentage: '超额百分比',
            process: '处理',
            cancel: '取消',
            SAPSO: 'SO编号',
            addSO: '新增 SO',
            editSO: '编辑 SO',
            DN: 'DN编号',
            contractNumber: '合同号',
            PHCode: 'PHCode',
            contractStatus: '合同状态',
            ordersType: '订单类型',
            orderStatus: '订单状态',
            finalEditer: '最后修改人',
            orderApplicationName: '订单处理人',
            orderApplicationTime: '处理时间',
            remark: '备注',
            shipper: '货主',
            contractView: '查看合同',
            resendMail: '重发邮件',
            updateSO: '录入SO',
            updateDN: '录入DN',
            applicationDetail: '操作记录',
            quantity: '数量',
            transportType: '运输方式',
            receiverAddress: '收货地址',
            orderProcess: '订单处理',
            cancelReason: '取消原因',
            warehouseShortName: '库房简称',
            adjustmentQuantity: '调整量',
            loadQuantity: '件装量',
            settlementQuantity: '数量结算',
            remainingQuantity: '剩余计划',
            completionRate: '计划达成率',
            requestStatus: '状态',
            totalMoney: '金额',
            inventory: '当月库存',
            approvalContract: '审核合同',
            contractFile: '合同文件',
            downloadContractFile: '下载合同文件',
            confirmChangeContractStatus: '确认发送文本合同？',
            confirmReSignature: '确认重新电子签章？',
            changeContractStatusSuccess: '发送文本合同成功',
            reSignatureSuccess: '重新电子签章成功',
            canNotBeFadadaSign: '该合同无法签章，是否生成？选择【确定】，生成未盖章的合同，发送经销商。',
            approvalSuccess: '合同审批成功',
            rejectSuccess: '合同拒绝成功',
            total: '产品数量合计',
            deliveryMonth: '到货月份',
            deliveryMonthBeEmpty: '到货月份不能为空',
            logisticsName: '承运商',
            priceMode: '运输方式',
            warningStatus: '预警状态',
            licensePlate: '车牌号',
            departureTime: '仓库发车时间',
            estimatedDeliveryTime: '预计送达时间',
            arrivalWarningTime: '到达预警时间',
            actualDeliveryTime: '实际送达时间',
            actualDeliveryStatus: '送达状态',
            actualSigningTime: '实际签收时间',
            actualSigningStatus: '签收状态',
            signatureMode: '签收方式',
            signatureRemark: '破损签收备注',
            contractReadyDays: '合同准备天数',
            deliveryDays: '物流天数',
            signatureDays: '到货天数',
            deliveryProgress: '物流进度',
            deliveryGPSDetail: 'GPS记录',
            deliveryProduct: 'DN产品列表',
            coordinateType: '坐标系类型',
            longitude:'经度',
            latitude: '纬度',
            updateTime: '承运商更新时间',
            syncTime: 'SODA同步时间',
            shipperWarehouse: '货主仓库',
            customerWarehouse: '客户仓库',
            coordinateTypeAlias: '坐标系别名',
            address: '地理位置',
            exportGps: '导出GPS',
            windowsDate: '窗口期',
            deliveryDate: '预计发货日期',
            arrivedDate: '预计到货日期',
            windowsStatus: '窗口期状态',
            warehouse: '实体仓',
            refreshShippingCalendar: '刷新数据',
            refreshShippingClaendarSuccess: '刷新Shipping Calendar数据成功',
            agreementPaymentDays: '协议账期',
            temporaryPaymentDays: '临时账期',
        },
        orderProcess: {
            batchReturn: '批量合同盖章',
            batchImportSO: '批量导入SO',
            batchImportSN: '批量导入DN',
            contractReturn: '合同盖章',
            resendMailSuccess: '邮件重发成功',
            lastOneOrder: '至少选择一个订单',
            leastOneDN: '至少有一个DN编号',
            leastOneSO: '至少有一个SO编号',
            operatingSuccess: '操作成功',
            confirmOperating: '确认操作？',
            undefinedContractPDF: '合同文件丢失，请联系管理员',
            SONull: 'SO不能为空',
            SOLength: 'SO长度过长',
            DNNull: 'DN不能为空',
            DNLength: 'DN长度过长',
            DNRepeat: '已存在该DN编号',
            SORepeat: '已存在该SO编号',
            remarkLength: '备注过长',
            importBillTemplate: '账单信息导入模板下载',
            importExpressTemplate: '快递信息导入模板下载',
            invoiceView: '查看发票',
            editContract: '编辑订单',
            returnContract: '合同回传',
            batchReturnContract: '批量合同回传',
            invoiceName: '发票名称',
            uploadTime: '上传时间',
            downLoad: '下载',
            chooseContract: '未选择任何合同',
            settingContractFooter: '合同页脚设置',
            contractFooter: '合同页脚',
            contractFooterNull: '合同页脚不能为空',
            confirmSave: '确认保存？',
            requestQuantity: '申请数量',
            orderDetail: '订单明细',
            sendContractFile: '发送文本合同',
            reSignature: '重新电子签章'
        },
        maintenance: {
            PDFInvoiceIsNullMessage: '尚未上传文件',
            paymentDateIsNotNull: '回款日期不能为空',
            amountIsNotNull: '回款金额不能为空',
            editBillInfo: '编辑账单信息',
            editBillInfoDetail: '编辑账单明细',
            billingMmonth: '账单月份',
            billingNumber: '账单号',
            SONumber: 'SO编号',
            invoicenumber: '发票号',
            invoiceView: '查看发票',
            invoiceMonth: '发票日期',
            paybackDate: '回款日期',
            valueDate: '实际回款日期',
            billingDate: '账单日期',
            paybackMoney: '回款金额',
            expressDeliveryCompany: '快递公司',
            expressDeliveryNumber: '快递号',
            expressDeliveryDate: '快递日期',
            contractNumer: '合同号',
            uploadYearMonth: '上传年月',
            batch: '批号',
            billDetail: '账单明细',
            expressBatchUpload: '快递信息批量导入',
            confirmDeleteBill: '确定删除账单？',
            receiverEmployeeName: '负责人',
        },
        orderdetail: {
            productReferred: '产品简称',
            materialGroup: '分型',
            productQuantity: '产品数量',
            receiverTEL: 'Tel',
            receiverLegal: '法人',
            recieverTaxNumber: '税号',
            receiverAddress: '地址',
            receiverContactAddress: '联系人地址',
            bankAmount: '客户开户账号',
            bankName: '客户开户银行',
            email: '客户电子邮箱',
            materialCode: '物料Code',
            material: '物料',
            moreColumn: '更多字段',
            shipperName: '货主名称',
            shipperCode: '货主编码',
            shipperAddress: '货主地址',
            shipperBank: '货主开户银行',
            shipperBankNumber: '货主开户账号',
            productName: '产品名称',
            productCode: '产品编码',
            commonName: '通用名',
            specification: '规格',
            manufacturer: '生产商',
            filingVoucherCode: '备案凭证编码',
            warehouseName: '库房名称',
            warehouseAddress: '库房地址',
            effectiveStartTime: '有效开始时间',
            effectiveEndTime: '有效结束时间',
            price: '单价',
            expirationOfPay: '付款期限(天)',
            orderLogOperator: '操作人',
            orderLogOperateTime: '操作时间',
            orderLogType: '记录类型',
            orderLogStep: '操作',
            SOUpdateDate: 'SO编辑时间',
            DNUpdateDate: 'DN编辑时间',
            contractSendDate: '合同发送时间',
            contractReceiveDate: '合同接收时间',
            customerSignatureTime: '客户签章时间',
            contractConfimTime: '合同确认时间',
            contractReturnDate: '合同回收时间',
            contractCancelDate: '合同取消时间',
            newOrder: '新建订单',
            selectionType: '选择分型',
            capacity: '件容量',
            availablePlan: '可用计划',
            plannedSurplus: '计划剩余',
            numberPieces: '件数',
            customerNameIsMandatory: '客户名称为必选项',
            theOwnerIsMust: '货主为必选项',
            theAddressIsMust: '收货地址为必选项',
            selectLeastOneType: '至少选择一个分型',
            greaterThanZero: '订单中得采购数量必须大于0',
            description: '备注'
        },
        paymentCollection: {
            displayShipperPayment: '是否显示默克货主回款',
            commercialPHCode: '商业公司PHCode',
            addAntherName: '新增别名',
            manualSyn: '手工同步',
            synRecord: '同步记录',
            anotherNameNoEmpty: '别名不能为空',
            receiverName: '商业公司不能为空',
            isManualSyn: '是否手工同步回款信息',
            nameInequality: '别名和商业公司不能相同',
            whetherDeleteAnotherName: '是否删除该别名?',
            distributorProvinceCity: '经销商省份/城市',
            distributorEmployeeNameCn: '经销商负责人'
        },
        partnerManagement: {
            orderNumber: '订单号',
            partnerName: '合作方名称',
            employeeName: '负责人',
            paymentStatus: '回款状态',
            paymentReceived: '已回款',
            unpaid: '未回款',
            purchaseName: '采购人',
            billType: '账期',
            amount: '账单金额',
            price: '价格',
            paymentDay: '账期',
            entityStatus: '是否有效',
            importPartnerCustomerProduct: '导入合作方客户产品关联',
            whetherDelete: '是否确认删除选中内容？',
            deleteSuccess: '删除成功',
            editPartnerProduct: '编辑合作方客户产品关联',
            partnerNameNull: '合作方名称不可以为空',
            receiverNameNull: '客户名称不可以为空',
            paymentDayValidate: '账期必须是非负整数',
            entityStatusNull: '请选择是否有效',
            selectPartner: '选择合作方',
            selectCustomer: '选择客户',
            batchImport: '批量导入&变更',
            priceValidate: '价格必须不能为负数',
            paybackDate: '应回款日期',
        }
    },
    'enUS': {
        orderProcessing: {
            SAPCode: 'SAPCode',
            confirmCancelReason: 'Confirm cancel?',
            canceSuccess: 'Cancel success',
            transportTypeNull: 'Transport method cannot be empty',
            receiverAddressNull: 'Shipping address cannot be empty',
            cancelReasonNull: 'Cancellation reason cannot be empty',
            adjustedQuantityExceed: 'Adjustment amount exceeds adjustable range',
            contractRepeat: 'The contract has been scanned',
            materialNull: 'Item cannot be empty',
            warehouseNull: 'Treasury cannot be empty',
            processSucess: 'Successful processing',
            applicationDate: 'Date of Application',
            applicationTime: 'Application time',
            clientProvinceCity: 'Customer province/city',
            clientProvince: 'Customer province',
            clientCity: 'Customer city',
            applicant: 'Applicant',
            applicationNumber: 'Requisition number',
            clientName: 'Clients name',
            clientAddress: 'Clients address',
            clientShortName: 'Customer short name',
            clientShortPHCode: 'Customer PHCode',
            isOverdraft: 'Is it overful',
            overdraftMoney: 'Overdraft money',
            overdraftPercentage: 'Excess percentage',
            process: 'Process',
            cancel: 'Cancel',
            SAPSO: 'SO Number',
            addSO: 'Add SO',
            editSO: 'Edit SO',
            DN: 'DN Number',
            contractNumber: 'Contract No',
            PHCode: 'PHCode',
            orderStatus: 'Order Status',
            contractStatus: 'Contract Status',
            ordersType: 'Order Type',
            finalEditer: 'Last Modified',
            orderApplicationName: 'Order processor',
            orderApplicationTime: 'Processing time',
            Remark: 'Remarks',
            shipper: 'Cargo owner',
            contractView: 'View contract',
            resendMail: 'Resend Mail',
            updateSO: 'Enter SO',
            updateDN: 'Enter DN',
            applicationDetail: 'Operation Record',
            quantity: 'Quantity',
            transportType: 'Transport Type',
            receiverAddress: 'Shipping address',
            orderProcess: 'Order Processing',
            cancelReason: 'Cancel Reason',
            warehouseShortName: 'Short name for warehouse',
            adjustmentQuantity: 'Adjustment Amount',
            loadQuantity: 'Piece Quantity',
            settlementQuantity: 'Quantity settlement',
            remainingQuantity: 'Remaining Plan',
            completionRate: 'Plan Completion Rate',
            requestStatus: 'Status',
            totalMoney: 'Amount',
            inventory: 'Current month inventory',
            approvalContract: 'Approval Contract',
            contractFile: 'Contract File',
            downloadContractFile: 'Download Contract',
            confirmChangeContractStatus: 'Confirm change contractStatus?',
            confirmReSignature: 'Confirm re signature?',
            changeContractStatusSuccess: 'Change contractStatus success?',
            reSignatureSuccess: 'Re signature success?',
            canNotBeFadadaSign: 'The contract cannot be signed. Do you want to generate it? Select OK to generate the unsealed contract and send it to the dealer.',
            approvalSuccess: 'Approval success',
            rejectSuccess: 'Reject success',
            total: 'Total product quantity',
            deliveryMonth: 'DeliveryMonth',
            deliveryMonthBeEmpty: 'Required',
            logisticsName: 'Logistics Name',
            priceMode: 'Transport Mode',
            warningStatus: 'Warning Status',
            licensePlate: 'License Plate',
            departureTime: 'Departure Time',
            estimatedDeliveryTime: 'Estimated Delivery Time',
            arrivalWarningTime: 'Arrival Warning Time',
            actualDeliveryTime: 'Actual Delivery Time',
            actualDeliveryStatus: 'Actual Delivery Status',
            actualSigningTime: 'Actual Signing Time',
            actualSigningStatus: 'Actual Signing Status',
            signatureMode: 'Signature Mode',
            signatureRemark: 'Signature Remark',
            contractReadyDays: 'Contract Ready Days',
            deliveryDays: 'Delivery Days',
            signatureDays: 'Signature Days',
            deliveryProgress: 'Delivery Progress',
            deliveryGPSDetail: 'GPS Detail',
            deliveryProduct: 'Product Detail',
            coordinateType: 'Coordinate Type',
            longitude:'Longitude',
            latitude: 'Latitude',
            updateTime: 'Update Time',
            syncTime: 'Sync Time',
            shipperWarehouse: 'Shipper Warehouse',
            customerWarehouse: 'Customer Warehouse',
            coordinateTypeAlias: 'Coordinate Type Alias',
            address: 'Address',
            exportGps: 'Export Gps',
            windowsDate: 'Windows Date',
            deliveryDate: 'Delivery Date',
            arrivedDate: 'Arrived Date',
            windowsStatus: 'Status',
            warehouse: 'Shipper Warehouse',
            refreshShippingCalendar: 'Refresh',
            refreshShippingClaendarSuccess: 'Successfully',
            agreementPaymentDays: 'Agreement Payment Days',
            temporaryPaymentDays: 'Temporary Payment Days',
        },
        orderProcess: {
            batchReturn: 'Batch contract stamp',
            batchImportSO: 'Batch Import SO',
            batchImportSN: 'Batch Import DN',
            contractReturn: 'Contract Seal',
            resendMailSuccess: 'Mail resend successfully',
            lastOneOrder: 'Select at least one order',
            leastOneDN: 'At least one DN number',
            leastOneSO: 'At least one SO number',
            operatingSuccess: 'Operation succeeded',
            confirmOperating: 'Confirm operation? ',
            undefinedContractPDF: 'The contract file is missing, please contact the administrator',
            SONull: 'SO cannot be empty',
            SOLength: 'The length of the SO is too long',
            DNNull: 'DN cannot be empty',
            DNLength: 'DN is too long',
            DNRepeat: 'This DN number already exists',
            SORepeat: 'This SO number already exists',
            remarkLength: 'Remarks are too long',
            importBillTemplate: 'Download billing information import template',
            importExpressTemplate: 'Express information import template download',
            invoiceView: 'View invoice',
            editContract: 'Edit Order',
            returnContract: 'Contract Back',
            batchReturnContract: 'Batch contract return',
            invoiceName: 'Invoice Name',
            uploadTime: 'Upload time',
            downLoad: 'Download',
            chooseContract: 'No contract selected',
            settingContractFooter: 'Contract Footer Settings',
            contractFooter: 'Contract Footer',
            contractFooterNull: 'Contract footer cannot be empty',
            confirmSave: 'Confirm save? ',
            requestQuantity: 'Request Quantity',
            orderDetail: 'Order Details',
            sendContractFile: 'Send Contract File',
            reSignature: 'Re Signature'
        },
        maintenance: {
            PDFInvoiceIsNullMessage: 'No files have been uploaded',
            paymentDateIsNotNull: 'The payment date cannot be empty',
            amountIsNotNull: 'Refund amount cannot be empty',
            editBillInfo: 'Edit Bill Information',
            editBillInfoDetail: 'Edit Bill Details',
            billingMmonth: 'Billing Month',
            billingNumber: 'Billing Number',
            SONumber: 'SO Number',
            invoiceView: 'View invoice',
            invoicenumber: 'Invoice number',
            invoiceMonth: 'Invoice Month',
            paybackDate: 'Payback Date',
            valueDate: 'Actual payment date',
            billingDate: 'Billing Date',
            paybackMoney: 'Payment Amount',
            expressDeliveryCompany: 'Express Company',
            expressDeliveryNumber: 'Express Number',
            expressDeliveryDate: 'Express Date',
            contractNumer: 'Contract Number',
            uploadYearMonth: 'Upload Month',
            batch: 'Batch number',
            billDetail: 'Bill Details',
            expressBatchUpload: 'Express Batch Upload',
            confirmDeleteBill: 'Confirm to delete bill？',
            receiverEmployeeName: 'CFS',
        },
        orderdetail: {
            productReferred: 'Product Abbreviation',
            materialGroup: 'Parting',
            productQuantity: 'Product Quantity',
            receiverTEL: 'Tel',
            receiverLegal: 'Corporate',
            recieverTaxNumber: 'Tax Number',
            receiverAddress: 'Address',
            receiverContactAddress: 'Contact Address',
            bankAmount: 'Customer Account Number',
            email: 'Customer Email',
            materialCode: 'Material Code',
            moreColumn: 'More',
            shipperName: 'Shipper Name',
            shipperCode: 'Cargo Owner Code',
            shipperAddress: 'Shipping address',
            shipperBank: 'Bank of the owners account',
            shipperBankNumber: 'Account Opening Account',
            productName: 'product name',
            productCode: 'Product Code',
            commonName: 'Common Name',
            specification: 'Specifications',
            manufacturer: 'Manufacturer',
            filingVoucherCode: 'Filing Voucher Code',
            warehouseName: 'Warehouse name',
            warehouseAddress: 'Warehouse Address',
            effectiveStartTime: 'Effective start time',
            effectiveEndTime: 'Effective end time',
            price: 'Unit Price',
            expirationOfPay: 'Payment Period (Days)',
            orderLogOperator: 'Operator',
            orderLogOperateTime: 'Operation time',
            orderLogType: 'Log Type',
            orderLogStep: 'Operation',
            SOUpdateDate: 'SO Edit Time',
            DNUpdateDate: 'DN Edit Time',
            contractSendDate: 'Contract Send Time',
            contractReceiveDate: 'Contract Received',
            customerSignatureTime: 'Customer signature time',
            contractConfimTime: 'Contract Confim Time',
            contractReturnDate: 'Contract recovery time',
            contractCancelDate: 'Contract cancellation time',
            newOrder: 'New Order',
            selectionType: 'Selection type',
            capacity: 'Capacity',
            availablePlan: 'Available plan',
            plannedSurplus: 'Planned surplus',
            numberPieces: 'Number of pieces',
            customerNameIsMandatory: 'Customer name is mandatory',
            theOwnerIsMust: 'The owner is a must',
            theAddressIsMust: 'The address is must',
            selectLeastOneType: 'Select at least one type',
            greaterThanZero: 'The quantity purchased in the order must be greater than 0',
            description: 'Description'

        },
        paymentCollection: {
            displayShipperPayment: 'Is display Merck Shipper Payment',
            commercialPHCode: 'Commercial company PHCode',
            addAntherName: 'Add alias',
            manualSyn: 'Manual synchronization',
            synRecord: 'Synchronous recording',
            anotherNameNoEmpty: 'Alias cannot be empty',
            receiverName: 'Commercial company cannot be blank',
            isManualSyn: 'Synchronize collection information manually',
            nameInequality: 'Alias and business company cannot be the same',
            whetherDeleteAnotherName: 'Delete this alias?',
            distributorProvinceCity: 'Distributor Province/City',
            distributorEmployeeNameCn: 'distributor Employee Name'
        },
        partnerManagement: {
            orderNumber: 'OrderNumber',
            partnerName: 'PartnerName',
            employeeName: 'EmployeeName',
            paymentStatus: 'PaymentStatus',
            paymentReceived: 'PaymentReceived',
            unpaid: 'Unpaid',
            purchaseName: 'PurchaseName',
            billType: 'BillType',
            amount: 'Amount',
            price: 'Price',
            paymentDay: 'PaymentDay',
            entityStatus: 'IsEffect',
            importPartnerCustomerProduct: 'Import',
            whetherDelete: 'Are you sure you want to delete it?',
            deleteSuccess: 'Successful',
            editPartnerProduct: 'Edit',
            partnerNameNull: 'Partner name can not be  empty',
            receiverNameNull: 'Customer name can not be  empty',
            paymentDayValidate: 'The billing period must be a positive integer of 0 or within 9 digits',
            entityStatusNull: 'Please select whether it is valid',
            selectPartner: 'Selecting a Partner',
            selectCustomer: 'Select Customer',
            batchImport: 'Batch Import & Update',
            priceValidate: 'The price cannot be negative.',
            paybackDate: 'Payback Date',
        }
    }
}
export default orderLocale


// WEBPACK FOOTER //
// ./src/locale/modules/orderLocale.js